//messages.js
export default {
    manufacturer_id: "Manufacturer",
    tank_manufacturers: "Tank Manufacturers",
    tank_manufacturer: "Tank Manufacturer",
    delete_tank_manufacturer: "Delete Tank Manufacturer",
    add_tank_manufacturer: "Add Tank Manufacturer",
    edit_tank_manufacturer: "Edit Tank Manufacturer",
    manufacturer: "Manufacturer",
    phone: "Phone",
    tank_name: "Tank Name",
    def_us_gallons: "Def Us Gallons",
    metric_diameter: "Metric Diameter",
    metric_height: "Metric Height",
    metric_width: "Metric Width",
    metric_length: "Metric Length",
    tank_manufacturers_specs: "Tank Manufacturers Specs",
    delete_tank_manufacturers_spec: "Delete Tank Manufacturers Spec",
    add_tank_manufacturers_spec: "Add Tank Manufacturers Spec",
    edit_tank_manufacturers_spec: "Edit Tank Manufacturers Spec",
    edit_spec: "Edit Spec",
};
